module.exports = __webpack_public_path__ + "static/img/psd.ba87fb06.png";